module.exports = __webpack_public_path__ + "img/HEAD.36aa83d1.png";